<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table visit-report-table">
                <thead>
                    <tr>
                        <th>
                            <input
                                type="checkbox"
                                :checked="isAllSelected"
                                :indeterminate="isIndeterminate"
                                @change="toggleAll"
                            />
                        </th>
                        <th>Item Name</th>
                        <th>Unit</th>
                        <th>Manufacturer</th>
                        <th>Reorder Qty</th>
                        <th>Stock in hand</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in tableItems" :key="i">
                        <td>
                            <input
                                type="checkbox"
                                :value="item.id"
                                v-model="selectedIds"
                                @change="emit('onSelectionChange', selectedIds)"
                            />
                        </td>
                        <td>{{ item.name }}</td>
                        <td>{{ item.unit_name }}</td>
                        <td>{{ item.supplier }}</td>
                        <td>{{ item.recorder_level }}</td>
                        <td>{{ item.stock_in_hand }}</td>
                    </tr>
                </tbody>
            </table>
        <p v-if="!tableItems.length" class="text-center mt-5">No data</p>
    </div>
</div>
</template>

<script setup>
import { ref, computed } from "vue";

const props = defineProps({
    tableItems: {
        type: Array,
    }
});

const emit = defineEmits(['onSelectionChange']);
const selectedIds = ref([]);

const isAllSelected = computed(() =>
    props.tableItems.length > 0 && selectedIds.value.length === props.tableItems.length
);

const isIndeterminate = computed(() =>
    selectedIds.value.length > 0 && selectedIds.value.length < props.tableItems.length
);

const toggleAll = (e) => {
    selectedIds.value = e.target.checked ? props.tableItems.map(item => item.id) : [];
    emit('onSelectionChange', selectedIds.value);
};
</script>

<style scoped>
.visit-report-table > :not(caption) > * > * {
    padding: 1rem !important;
}

.visit-report-table .pl-10px {
    padding-left: 10px !important;
}
</style>